import React, { Component } from 'react';
import _ from 'lodash';
import memoize from 'fast-memoize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ScreenLoader from '../ScreenLoader/ScreenLoader';
import Message from '../Message/Message';
import DatetimeTableCell from '../DatetimeTableCell/DatetimeTableCell';
import SeePositions from '../SeePositions/SeePositions';
import SportIcon from '../SportIcon/SportIcon';
import Table from '../Table/Table';
import Th from '../Th/Th';
import Api from '../../helpers/Api';
import './BetsOverview.css';

export default class BetsOverview extends Component {
  static isPrivate = true;

  constructor(props) {
    super(props);
    this.defaultSortBy = ['start_time', 'home_team', 'away_team', 'sport', 'order_id'];
    this.state = {
      events: null,
      trades: null,
      isLoading: false,
      sortBy: this.defaultSortBy[0],
      sortAsc: true,
    };
    this.sort = memoize(Table.sort);
    this.api = new Api('bets/open');
  }

  componentDidMount() {
    this.api.start({
      onBefore: this.requestWillStart.bind(this),
      onSuccess: this.requestDidComplete.bind(this),
      onError: this.requestDidCatch.bind(this),
    });
  }

  componentWillUnmount() {
    this.api.stop();
  }

  requestWillStart() {
    this.setState({ isLoading: true });
    this.props.updateRefresh(true, false);
  }

  requestDidComplete(data) {
    const { events, trades } = this.digestData(data);
    this.setState({ events, trades, isLoading: false });
    this.props.updateRefresh(false, false);
  }

  requestDidCatch(error) {
    this.setState({ isLoading: false });
    this.props.updateRefresh(false, error instanceof Api.CancelError ? false : error);
  }

  digestData(data) {
    const { sortBy, sortAsc } = this.state;
    const trades = _.groupBy(data, e => e.sport_event_id);
    let events = _.uniqBy(data, e => e.sport_event_id);
    events = events.map(e => ({ ...e, stake: _.sum(trades[e.sport_event_id].map(d => d.stake)) }));
    events = this.sort(events, [sortBy, ...this.defaultSortBy], sortAsc);

    return { events, trades };
  }

  sortBy(prop) {
    const { events, sortBy, sortAsc } = this.state;

    if (prop === sortBy) {
      // Already sorted by this property - reverse order only
      this.setState({ sortAsc: !sortAsc, events: events.reverse() });
    } else {
      const sorted = this.sort(events, [prop, ...this.defaultSortBy], true);
      this.setState({ sortBy: prop, sortAsc: true, events: sorted });
    }
  }

  render() {
    const {
      events, trades, isLoading, sortBy, sortAsc,
    } = this.state;

    if (!Array.isArray(events) || events.length < 1) {
      return isLoading
        ? <ScreenLoader />
        : <Message type="warning" text="No open trades" />;
    }

    const headings = {
      start_time: <FontAwesomeIcon icon="clock" />,
      display_name: 'Event',
      sport: 'Sport',
      stake: 'Stake',
    };

    return (
      <div className="row bets-overview">
        <div className="col-xs-12 table-scroll">
          <Table>
            <thead>
              <tr>
                {Object.keys(headings).map(col => (
                  <Th
                    key={col}
                    prop={col}
                    sortBy={sortBy}
                    sortAsc={sortAsc}
                    onSort={() => this.sortBy(col)}
                  >
                    {headings[col]}
                  </Th>
                ))}
                <th />
              </tr>
            </thead>
            <tbody>
              {events.map(e => (
                <tr key={e.sport_event_id}>
                  <DatetimeTableCell date={e.start_time} />
                  <td>{e.display_name}</td>
                  <td>
                    <SportIcon sport={e.sport} />
                  </td>
                  <td>€{e.stake.toLocaleString('en-GB', { maximumFractionDigits: 0 })}</td>
                  <td>
                    <SeePositions event={e} trades={trades[e.sport_event_id]} />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BetsOverview/BetsOverview.js